import request from '@/utils/request'

// 创建与真黄页
export function createYellowPages(data) {
  return request({
    url: '/yuzhen/yellow-pages/create',
    method: 'post',
    data: data
  })
}

// 更新与真黄页
export function updateYellowPages(data) {
  return request({
    url: '/yuzhen/yellow-pages/update',
    method: 'put',
    data: data
  })
}

// 删除与真黄页
export function deleteYellowPages(id) {
  return request({
    url: '/yuzhen/yellow-pages/delete?id=' + id,
    method: 'delete'
  })
}

// 获得与真黄页
export function getYellowPages(id) {
  return request({
    url: '/yuzhen/yellow-pages/get?id=' + id,
    method: 'get'
  })
}

// 获得自己的与真黄页
export function getUserYellowPages() {
  return request({
    url: '/yuzhen/yellow-pages/get/user',
    method: 'get'
  })
}

// 获得自己的与真黄页
export function getYellowPagesByCode(code) {
  return request({
    url: '/yuzhen/yellow-pages/get/code?code=' + code,
    method: 'get'
  })
}

// 根据域名获得自己的与真黄页
export function getYellowPagesByDomain(domain) {
  return request({
    url: '/yuzhen/yellow-pages/get/domain?domain=' + domain,
    method: 'get'
  })
}

// 根据审批code获得自己的与真黄页
export function getYellowPagesByApproveCode(code) {
  return request({
    url: '/yuzhen/yellow-pages/get/approve?code=' + code,
    method: 'get'
  })
}

// 获得与真黄页分页
export function getYellowPagesPage(query) {
  return request({
    url: '/yuzhen/yellow-pages/page',
    method: 'get',
    params: query
  })
}

// 搜索获得与真黄页分页
export function searchYellowPagesPage(query) {
  return request({
    url: '/yuzhen/yellow-pages/search',
    method: 'get',
    params: query
  })
}

// 导出与真黄页 Excel
export function exportYellowPagesExcel(query) {
  return request({
    url: '/yuzhen/yellow-pages/export-excel',
    method: 'get',
    params: query,
    responseType: 'blob'
  })
}
